/**
 * Website scripts
 */

jQuery(document).ready(function($){

    $('.c-hamburger').on('click', function(e) {
        e.preventDefault();
        if ( $('body').hasClass('nav-panels--open') ) {
            $('body').removeClass('nav-panels--open');
            removeMobmenu();
        } else {
            $('body').addClass('nav-panels--open');
            setupMobmenu();
        }
    });

    function doresize() {
        if ($('.menu-desktop').css('display') !== 'none') { //desktop menu is not visible
            $('body').removeClass('nav-panels--open');
            removeMobmenu();
        }
        removeMegamenu();
    }
    doresize();

    // Attach window listeners
    window.onresize = function(){ doresize(); }

    function removeMobmenu() {
        $('.mobmenu-holder').remove();
    }

    function setupMobmenu() {
        let megamenus = $('.megamenu-mobile').html() + $('.megamenu-shopall').html() + $('.megamenu-brochures').html() + $('.megamenu-joinus').html() + $('.megamenu-booktreatment').html() + $('.megamenu-ourstory').html() + $('.megamenu-blog').html() + $('.megamenu-contact').html(); // + contact link - how?

        $('body>.wrapper>header').append('<div class="mobmenu-holder">'+megamenus+'</div>');

    }

    function removeMegamenu() {
        $('.megamenu-holder').removeClass('megamenu-show');
        $('.menu-desktop nav li').removeClass('expanded');
        $('.megamenu-holder').remove();
    }

    function setupMegamenu(navitem) {

        $('.menu-desktop .nav-'+navitem).addClass('expanded');
        let megamenu = $('.megamenu-'+navitem).html();

        $('body>.wrapper>header').append('<div class="megamenu-holder megamenu-show">'+megamenu+'</div>');

        $('.megamenu-holder').append('<div class="btn-close-megamenu"></div>');
        $('.megamenu-holder .btn-close-megamenu').on('click', function(e) {
            removeMegamenu();
        });

        $('.megamenu-holder').mouseenter(function(){
            // do nothing
        }).mouseleave(function(){
            removeMegamenu();
        });

    }

    $('.menu-wrapper .menu-desktop nav li a[href="#"]').on('click', function(e) {
        e.preventDefault();
        return false;
    });

    $('.menu-wrapper .menu-desktop nav li').mouseenter(function(){

        if ( $('.menu-desktop nav li').hasClass('expanded') ) removeMegamenu();

        if ($(this).hasClass('nav-ourstory')) {
            setupMegamenu('ourstory');
        } else if ($(this).hasClass('nav-joinus')) {
            setupMegamenu('joinus');
        } else if ($(this).hasClass('nav-blog')) {
            setupMegamenu('blog');
        } else if ($(this).hasClass('nav-brochures')) {
            setupMegamenu('brochures');
        } else if ($(this).hasClass('nav-shopall')) {
            setupMegamenu('shopall');
        }

    }).mouseleave(function(){

    });

    $('.blog-content').fitVids();


    /*
    <div class="earnings-calculator">
      <div class="rangeslider-wrap section-container">
        <input type="range" min="500" max="4000" value="2250" step="10" labels="$500, $4000+" data-rangeslider>
      </div>
      <div class="total-earnings section-container">
        <h3>Up to <span class="earnings-value"></span> of all your sales</h3>
        <p>Earn approximately <span class="monthly-earnings"></span> every month (approximately <span class="semiannual-earnings"></span>+ in 6 months)</p>
      </div>
    </div>
     */

    //NB todo - NEW CODE:
    let rangeslider = document.querySelector('.rangeslider-wrap [data-rangeslider]')

    if (rangeslider) {
        rangeslider.addEventListener('input', (e) => {
            document.querySelector('.total-earnings .earnings-value').innerHTML = e.target.value;
            //NB todo - mod code output here
        })

        rangesliderJs.create(rangeslider, {
            onSlide: function () {
                console.log(this);
            }
        });
    }

    /* //ORIG CODE:
    $('input[type="range"]').rangeslider({
        polyfill: false,
        rangeClass: "rangeslider",
        disabledClass: "rangeslider--disabled",
        horizontalClass: "rangeslider--horizontal",
        fillClass: "rangeslider__fill",
        handleClass: "rangeslider__handle",
        onInit: function() {
            var e = 0;
            var d = "";
            $rangeEl = this.$range;
            var f = $rangeEl.find(".rangeslider__handle");
            var c = '<div class="rangeslider__handle__value">$' + (this.value).toLocaleString() + "</div>";
            f.append(c);
            if (this.value <= 500) {
                e = 0.2 * 100;
                d = 100
            } else {
                if (this.value >= 501 && this.value <= 999) {
                    e = 0.25 * 100;
                    d = 125
                } else {
                    if (this.value >= 1000 && this.value <= 1999) {
                        e = 0.3 * 100;
                        d = 300
                    } else {
                        if (this.value >= 2000 && this.value <= 2999) {
                            e = 0.35 * 100;
                            d = 700
                        } else {
                            if (this.value >= 3000 && this.value <= 3999) {
                                e = 0.4 * 100;
                                d = 1200
                            } else {
                                if (this.value >= 4000) {
                                    e = 0.45 * 100;
                                    d = 1800
                                }
                            }
                        }
                    }
                }
            }
            $(".earnings-value").text(e + "%");
            $(".monthly-earnings").text("$" + d.toLocaleString());
            $(".semiannual-earnings").text("$" + (d * 6).toLocaleString());
            var b = this.$element.attr("labels");
            b = b.split(", ");
            $rangeEl.append('<div class="rangeslider__labels"></div>');
            $(b).each(function(g, h) {
                $rangeEl.find(".rangeslider__labels").append('<span class="rangeslider__labels__label">' + h + "</span>")
            })
        },
        onSlide: function(b, c) {
            var d = this.$range.find(".rangeslider__handle__value");
            d.text("$" + (this.value).toLocaleString());
            if (this.value <= 500) {
                $earningsValue = 0.2 * 100;
                $monthlyEarnings = 100
            } else {
                if (this.value >= 501 && this.value <= 999) {
                    $earningsValue = 0.25 * 100;
                    $monthlyEarnings = 125
                } else {
                    if (this.value >= 1000 && this.value <= 1999) {
                        $earningsValue = 0.3 * 100;
                        $monthlyEarnings = 300
                    } else {
                        if (this.value >= 2000 && this.value <= 2999) {
                            $earningsValue = 0.35 * 100;
                            $monthlyEarnings = 700
                        } else {
                            if (this.value >= 3000 && this.value <= 3999) {
                                $earningsValue = 0.4 * 100;
                                $monthlyEarnings = 1200
                            } else {
                                if (this.value >= 4000) {
                                    $earningsValue = 0.45 * 100;
                                    $monthlyEarnings = 1800
                                }
                            }
                        }
                    }
                }
            }
            $(".earnings-value").text($earningsValue + "%");
            $(".monthly-earnings").text("$" + $monthlyEarnings.toLocaleString());
            $(".semiannual-earnings").text("$" + ($monthlyEarnings * 6).toLocaleString())
        },
        onSlideEnd: function(b, c) {}
    })
       */
});
